// extracted by mini-css-extract-plugin
module.exports = {"body":"Text_body__ldD0k","heading":"Text_heading__jNwbK","pageHeading":"Text_pageHeading__VhZNf","sectionHeading":"Text_sectionHeading__cIo0_"};